import { render, staticRenderFns } from "./ComplaintDialog.vue?vue&type=template&id=7b073924&scoped=true&"
import script from "./ComplaintDialog.vue?vue&type=script&lang=js&"
export * from "./ComplaintDialog.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintDialog.vue?vue&type=style&index=0&id=7b073924&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b073924",
  null
  
)

export default component.exports